module.exports = __webpack_public_path__ + "img/logo.23eec18a.png";